<template>
  <div class="content">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishText"
      @load="handleGetPostList"
    >
      <div class="list" v-if="list.length > 0">
        <div v-for="item in list" :key="item.id" class="list_item">
          <div class="avatar">
            <img class="img" :src="userAvatar[item.role]" alt="" />
          </div>
          <div class="info">
            <div class="user">
              <div class="user_data">
                <span class="name">
                  {{ item && item.realName }}
                </span>
                <span class="user_type">
                  <img
                    v-if="item.role == 1"
                    class="img1"
                    src="../../../assets/student/frame_one.png"
                    alt=""
                  />
                  <img
                    v-if="item.role == 3"
                    class="img2"
                    src="../../../assets/student/frame_two.png"
                    alt=""
                  />
                  <img
                    v-if="item.role == 2"
                    class="img2"
                    src="../../../assets/student/frame_three.png"
                    alt=""
                  />
                </span>
              </div>
              <div class="time" v-if="item.role == 3">
                报名：{{
                  $moment(parseInt(item.joinTime)).format("YYYY-MM-DD")
                }}
              </div>
            </div>
            <div class="hospital">{{ item.role == 1 ? '强生医疗科技' : item.hospitalName }}</div>
          </div>
        </div>
      </div>
      <div class="empty-block" v-else-if="isNone">
        <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
        <div class="empty-txt">暂无内容</div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getStudent } from '@/api/student'
import { userAvatar } from '../data'
export default {
  props: {
    areaId: ''
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      pageObj: {
        pageNo: 1,
        pageSize: 10
      },
      userAvatar,
      isNone: false,
      finishText: '没有更多了'
    }
  },
  methods: {
    handleGetPostList() {
      let params = {
        pageNum: this.pageObj.pageNo,
        pageSize: this.pageObj.pageSize,
        areaId: this.areaId
      }
      getStudent(params)
        .then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.loading = false
              this.finished = true
              return false
            }

            this.loading = false
            if (res.data.list.length < this.pageObj.pageSize) {
              this.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.list = this.list.concat(res.data.list)
            }
            this.pageObj.pageNo++
            if (this.list.length === 0) {
              this.isNone = true
              this.finishText = ''
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    }
  }
}
</script>

<style scoped lang="less">
.content {
  min-height: calc(100vh - 260px);
  background: linear-gradient(180deg, #f6f8fa 6%, #edf1f4 8%, #f2f7fa 100%);
}
.list {
  padding: 10px 16px;
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    #f6f8fa 0%,
    #f6f8fa 6%,
    #f6f8fa 8%,
    #f6f8fa 100%
  );
  &_item {
    width: 343px;
    min-height: 74px;
    margin-bottom: 8px;
    background-color: #fff;
    border-radius: 12px;
    padding: 14px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .avatar {
      width: 42px;
      height: 42px;
      margin-right: 6px;
      border-radius: 50%;
      overflow: hidden;
      .img {
        width: 42px;
        height: 42px;
      }
    }
    .info {
      width: 275px;
      .user {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        align-items: center;
        .user_data {
          display: flex;
          align-items: center;
          .name {
            margin-right: 4px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
          }
          .user_type {
            transform: translateY(2px);
            .img1 {
              width: 39px;
              height: 13px;
            }
            .img2 {
              width: 29px;
              height: 13px;
            }
          }
        }
        .time {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 12px;
          color: #7a8494;
        }
      }
      .hospital {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 14px;
        color: #7a8494;
      }
    }
  }
}
.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/studentList.vue